import React, { useEffect } from 'react';
import Form from 'screens/shared/form';
import { actions, ACTIONS_TYPES } from 'redux/local';
import {
  AVAILABILITY_ZONE, AVAILABILITY_ZONE$, RESOURCE_TYPE, STORAGE_TYPE, VALIDATION,
} from 'constant';
import { enumToArray, objectToOptions, _t } from 'utils';
import Icon from 'screens/shared/icon';
import { useSelector } from 'react-redux';
import { CLOUD_INIT } from 'constant/cloud-init';
import { formField } from 'types';
import { withRouter } from 'react-router-dom';

export default withRouter(({
  storage = {}, isEdit = false, isShowAttachButton = false, match,
}) => {
  const { dcId, id: serverId } = match.params;
  const { id } = storage;

  const { [ACTIONS_TYPES.BACKUP_UNIT.GET_ALL]: backupUnits = [] } = useSelector((e) => e);
  useEffect(() => {
    actions.backupUnits.getAll();
  }, []);

  const model = {
    name: '',
    availabilityZone: AVAILABILITY_ZONE.AUTO,
    size: 10,
    type: STORAGE_TYPE.SSD,
    image: '',
    imagePassword: '',
    sshKey: '',
    ...storage,
  };

  const fields = [
    formField.toggle({
      name: 'isAttachButton',
      setTitle: (e) => (
        e.isAttachButton ? (
          <span className="attach-volume-button">
            <Icon name="plus" style={{ marginRight: 5 }} />
            Add new volume
          </span>
        ) : (
          <span className="attach-volume-button">
            <Icon name="paperclip" style={{ marginRight: 5 }} />
            Attach exsiting volume
          </span>
        )
      ),
      setVisibility: () => isShowAttachButton,
    }),
    formField.volume({
      name: 'volume',
      dcId,
      setVisibility: (e) => e.isAttachButton,
    }),
    formField.text({
      name: 'name',
      title: _t('Name'),
      setVisibility: (e) => !e.isAttachButton,
    }),
    formField.slider({
      name: 'size',
      title: _t('Size'),
      range: [10, 1000],
      showValue: true,
      setVisibility: (e) => !e.isAttachButton,
    }),
    formField.dropdown({
      name: 'availabilityZone',
      title: _t('Availability Zone'),
      options: [...enumToArray(AVAILABILITY_ZONE).map((e) => [e, AVAILABILITY_ZONE$[e]])],
      setVisibility: (e) => !isEdit && !e.isAttachButton,
    }),
    formField.dropdown({
      name: 'type',
      title: _t('Type'),
      options: [...objectToOptions(STORAGE_TYPE, [STORAGE_TYPE.DAS])],
      setVisibility: (e) => !isEdit && !e.isAttachButton,
    }),
    formField.hdd({
      name: 'image',
      setVisibility: (e) => !isEdit && !e.isAttachButton,
      dcId,
    }),
    formField.password({
      name: 'imagePassword',
      title: 'Image Password',
      setVisibility: (e) => !isEdit && !!e?.image?.licenceType && e?.image?.type !== RESOURCE_TYPE.SNAPSHOT,
    }),
    formField.textarea({
      name: 'sshKey',
      title: _t('SSH Key'),
      // eslint-disable-next-line max-len
      setVisibility: (e) => !isEdit && (e?.image?.licenceType ? e?.image?.licenceType === 'LINUX' && e?.image?.type !== RESOURCE_TYPE.SNAPSHOT : false),
    }),
    formField.userData({
      name: 'userData',
      title: 'User Data',
      setVisibility: (e) => !isEdit && e?.image?.cloudInit === CLOUD_INIT.V1,
    }),
    formField.dropdown({
      name: 'backupunitId',
      title: 'Backup Unit',
      setVisibility: (e) => !isEdit && !!e?.image?.licenceType && e?.image?.type !== RESOURCE_TYPE.SNAPSHOT,
    }),
  ];

  const changeFields = [
    {
      name: 'backupunitId',
      props: {
        options: [...backupUnits.map(({ id: _id, properties }) => [
          _id,
          <span>
            {properties.name}
            <small>{` (${properties.email})`}</small>
          </span>,
        ])],
      },
    },
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, max: 255 },
    { name: 'imagePassword', type: VALIDATION.STRING, min: 5 },
    { name: 'sshKey', type: VALIDATION.REQUIRED },
    { name: 'volume', type: VALIDATION.REQUIRED },
  ];

  const onSave = (values) => {
    const {
      image, imagePassword, sshKey, volume, backupunitId, isAttachButton, ...properties
    } = values;

    if (image) {
      properties.image = image.id;
      if (image.type !== RESOURCE_TYPE.SNAPSHOT) properties.imagePassword = imagePassword;
      if (backupunitId) properties.backupunitId = backupunitId;
      if (image.licenceType === 'LINUX') properties.sshKeys = [sshKey];
    } else {
      properties.licenceType = 'LINUX';
    }

    if (!dcId && serverId) {
      return actions.storage.create({ dcId: serverId, properties });
    }

    if (isAttachButton) {
      return actions.server.attachVolume({ dcId, id: serverId, volumeId: volume?.id });
    }

    if (id) {
      const { name, size } = properties;
      return actions.storage.update({ dcId, id, properties: { name, size } });
    }

    return actions.storage.createInServer(isShowAttachButton ? { dcId, properties, serverId } : { dcId, properties });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={model}
      onSubmit={onSave}
      isCancel={false}
      validations={validations}
      changeFields={changeFields}
    />
  );
});
